import { render, staticRenderFns } from "./SupiTable.vue?vue&type=template&id=e62d2ad2&scoped=true&"
import script from "./SupiTable.vue?vue&type=script&lang=js&"
export * from "./SupiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62d2ad2",
  null
  
)

export default component.exports